module.exports = __webpack_public_path__ + "img/banner3.a15bda61.jpg";